<template>
  <highcharts ref="chart" :options="options" />
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'RulesPie',
  props: {
    scenarios: {
      type: Array,
      default: function () {
        return []
      }
    },
    titleSize: {
      type: String,
      default: '18px'
    },
    height: {
      type: Number,
      default: 400
    },
    exporting: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    nRules: function () {
      return this.scenarios
        .map((obj) => obj.rules.length)
        .reduce((sum, a) => sum + a, 0)
    },
    series: function () {
      let series = []
      for (let scenario of this.scenarios) {
        for (let rule of scenario.rules) {
          let oindex = series.findIndex((obj) => obj.name === rule.name)
          if (oindex < 0) {
            series.push({
              name: rule.name,
              y: 1
            })
          } else {
            series[oindex].y += 1
          }
        }
      }
      return series.sort((a, b) => b.y - a.y)
    },
    options: function () {
      let self = this
      return {
        chart: {
          type: 'pie',
          height: this.height
        },
        exporting: {
          enabled: this.exporting
        },
        title: {
          verticalAlign: 'middle',
          floating: true,
          style: {
            fontSize: this.titleSize
          },
          text: `<b>${self.nRules} ${self.$t('compGraphicsRulesPie.rules')}</b>`
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: 'ssss',
            colorByPoint: true,
            data: this.series
          }
        ],
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return `${this.key} ${self.$t('compGraphicsRulesPie.used')} <b>${
              this.y
            }</b> ${self.$t('compGraphicsRulesPie.times')} (${
              Math.round(this.percentage * 10) / 10
            }%)`
          }
        }
      }
    }
  }
}
</script>
